import React, { createContext, useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../api"; // Configuração do Axios

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null); // Armazena os dados do usuário
  const [loading, setLoading] = useState(true); // Indica o estado de carregamento inicial
  const navigate = useNavigate();
  const location = useLocation();

  // Função para logout encapsulada com useCallback
  const logout = useCallback(() => {
    localStorage.removeItem("token");
    delete api.defaults.headers.common["Authorization"];
    setIsAuthenticated(false);
    setUser(null);
    navigate("/login");
  }, [navigate]);

  // Verificar autenticação no início
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      // Configura o token no cabeçalho Authorization
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      // Busca os dados do usuário
      api
        .get("/usuarios/me")
        .then((response) => {
          setIsAuthenticated(true);
          setUser(response.data);
        })
        .catch((error) => {
          console.error("Erro ao carregar usuário:", error);
          logout(); // Remove o token e redireciona se houver erro
        })
        .finally(() => {
          setLoading(false); // Conclui o carregamento inicial
        });
    } else {
      setIsAuthenticated(false);
      setUser(null);
      setLoading(false);

      // Verificar se a rota atual requer autenticação
      const publicRoutes = ["/login", "/reset-senha"]; // Rotas públicas
      if (!publicRoutes.includes(location.pathname)) {
        navigate("/login"); // Redirecionar apenas se a rota não for pública
      }
    }
  }, [navigate, location.pathname, logout]);

  // Função para login
  const login = (token) => {
    localStorage.setItem("token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setIsAuthenticated(true);

    // Carrega os dados do usuário após o login
    api
      .get("/usuarios/me")
      .then((response) => {
        setUser(response.data);
        navigate("/"); // Redireciona para a página inicial
      })
      .catch((error) => {
        console.error("Erro ao carregar dados do usuário após login:", error);
      });
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, user, login, logout, loading }}
    >
      {children}
    </AuthContext.Provider>
  );
};
